//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
// Using `import uuid from 'uuid/v4';` will sometimes cause an error when
// @nuskin/design-components is being imported into another package.
import { v4 as uuid } from 'uuid';
import { VLayout, VTextField } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

export default {
  components: {
    NsIcon,
    VTextField,
    VLayout,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    /** decide to validate on blur or not */
    validateOnBlur: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: () => uuid(),
    },
    dataTestid: {
      type: String,
      default: '',
    },
    ref: {
      type: String,
      default: 'input',
    },
    icon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredLabel: {
      type: String,
      default: 'required',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    pattern: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  computed: {
    requiredRules() {
      if (this.required) {
        return [(v) => !!v || this.requiredLabel];
      }
      return [];
    },
  },
  watch: {
    inputValue(val) {
      /**
       * The input event, handled for v-model support.
       *
       * @event input
       * @type {string}
       */
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    },
  },
  methods: {
    onBlur() {
      this.$emit('input', this.inputValue);
    },
  },
};
